import { FunctionComponent, useState } from 'react'

import { validSeasonId, validTypeOfSport } from '@hooks/useSportCompetitorsList'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import FmTOnboardingContainer from '@components/FmtOnboardingContainer/FmTOnboardingContainer'
import SportCompetitorsListComponent from '@components/SportCompetitorsList'

export type SportCompetitorsListProps = {
  seasonId: string
  typeOfSport: 'soccer'
}

const SportCompetitorsList: FunctionComponent<SportCompetitorsListProps> = ({
  typeOfSport,
  seasonId,
}) => {
  const [showFmtOnboardingContainer, setShowFmtOnboardingContainer] =
    useState<boolean>(true)

  if (!validSeasonId(seasonId)) {
    return null
  }
  if (!validTypeOfSport(typeOfSport)) {
    return null
  }

  return (
    <>
      <FmTOnboardingContainer
        position="sportCompetitorsList"
        showFmtOnboardingContainer={showFmtOnboardingContainer}
        setShowFmtOnboardingContainer={setShowFmtOnboardingContainer}
      />
      <SportCompetitorsListComponent
        typeOfSport={typeOfSport}
        seasonId={seasonId}
      />
    </>
  )
}

const widget = {
  kind: ['sport-competitors-list'],
  component: SportCompetitorsList,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
